"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactLog = void 0;
const tslib_1 = require("tslib");
const apigw_models_1 = require("@integration/apigw-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const enums_1 = require("./enums");
class ContactLog extends apigw_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsEnum)(enums_1.ContactLogType),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({
        example: enums_1.ContactLogType.CONTACT_LOG,
        description: `The type of contactlog. Use ${enums_1.ContactLogType.CONTACT_LOG} if there has been interaction with the customer, and ${enums_1.ContactLogType.SERVICE_REQUEST} if there was no interaction between Essent/Energiedirect and the customer.`,
    }),
    (0, class_transformer_1.Expose)({ name: 'contact_log_type' }),
    tslib_1.__metadata("design:type", String)
], ContactLog.prototype, "contactLogType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsEnum)(enums_1.Channel),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({
        example: enums_1.Channel.MIJN_ESSENT,
        description: `The channel to which how the contact has taken place`,
    }),
    tslib_1.__metadata("design:type", String)
], ContactLog.prototype, "channel", void 0);
exports.ContactLog = ContactLog;
